<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <v-select
      class="v-select-style"
      :class="{ error: error }"
      v-model="selected"
      :getOptionLabel="getOptionLabel"
      :options="options"
      :placeholder="placeholder"
    >
      <template #no-options>
        <div class="text-xs">
          {{ text }}
        </div>
      </template>
    </v-select>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  inheritAttrs: false,
  components: {
    vSelect,
  },
  props: {
    url: String,
    id: {
      type: String,
      default() {
        return `vue-select-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    getOptionLabel: {
      type: Function,
      default: (item) => item.name,
    },
    text: String,
    modelValue: Object,
    options: {
      type: Array,
      default: [],
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.modelValue,
    }
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected)
    },
    modelValue(modelValue) {
      this.selected = modelValue;
    },
  },
}
</script>
<style>
.v-select-style .vs__dropdown-toggle {
  @apply appearance-none rounded-none bg-white border-solid border-t-0 border-l-0 border-r-0 border-gray-200 focus:border-blue-400;
  padding: 5px 0px 5px 0px;
}
.v-select-style .vs__dropdown-menu {
  @apply appearance-none rounded-none border-solid border-b-0 border-l-0 border-r-0 border-blue-400 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200;
}
.v-select-style .vs__selected {
  @apply leading-normal text-gray-700;
}
.v-select-style.error .vs__dropdown-toggle {
  @apply border-b-red-500;
}
</style>
